//@ts-ignore
import { tw } from "@careinfo/tailwind";
import loadable from "@loadable/component";
import { toast } from "react-toastify";
import { InferType } from "yup";
import APIS from "../../constant/EndPoint";
import usePostHook from "../../customHooks/usePostHook";
import CreateIcon from "../../Icons/CreateIcon";
import { createShiftValidationForm } from "../../utils/validationSchemas";

const CreateShiftComponent = loadable(
  () => import("../../components/Shift/CreateShift")
);

const CreateShift = () => {
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["shift"],
    navigateURL: "/human-resource-management/shift",
  });

  const handleCreate = async (
    values: InferType<typeof createShiftValidationForm>,
    setError: any
  ) => {
    const url = `${APIS.SHIFT}`;

    const formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      toast.error(err);
    }
  };

  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Create Staff Details
        </span>
      </div>
      <CreateShiftComponent
        isLoading={isPostLoading}
        handleCreate={handleCreate}
      />
    </>
  );
};
export default CreateShift;
